import get from 'lodash.get';
import React, { Fragment, Component } from 'react';
import styled from 'react-emotion';

import theme from '@jetshop/ui/utils/theme';
import { Above } from '@jetshop/ui/Breakpoints';
import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import t from '@jetshop/intl';
import { PaginationBehaviour } from '@jetshop/ui/Pagination';
import { PaginationWrapper } from '@jetshop/ui/Pagination/Pagination';
import FilterContext from '@jetshop/core/components/Filters/FilterContext';

import Pagination from '../CategoryPage/Pagination';

import ProductGrid from '../CategoryPage/ProductGrid';
import ProductList from '../CategoryPage/ProductList';
import GridProduct, {
  ProductBlockLink,
  ProductWrapper
} from '../CategoryPage/GridProduct';
import ListProduct, {
  ProductBlockLink as ProductBlockLinkList
} from '../CategoryPage/ListProduct';
import CategoryToolbar from '../CategoryPage/CategoryToolbar';

import SearchMeta from './SearchMeta';
import MaxWidth from '../Layout/MaxWidth';
import { ProductsPerPageFix } from '../CategoryPage/CategoryPage';

const Header = styled('header')``;

const StyledMaxWidth = styled(MaxWidth)`
  ${theme('below.md')} {
    padding: 0;
  }
`;

const Matches = styled('div')`
  text-align: center;
  color: gray;
  padding: 1.5rem 0;
  h1 {
    font-size: 1.8rem;
    margin: 10px auto;
    color: black;
  }
`;

const Container = styled('div')`
  padding: 0 0.75rem;
  .sortBy ~ svg {
    display: none;
  }
  .sortBy {
    display: none;
  }
  ${theme('below.md')} {
    padding: 0;
  }

  ${ProductBlockLink}, ${ProductBlockLinkList} {
    opacity: 1;
  }
  ${ProductWrapper} {
    margin: 0;
  }
`;

const StyledPaginationWrapper = styled(PaginationWrapper)`
  width: 100%;
  margin-top: 10px;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #9a9a9a;
  > div {
    align-items: center;
  }
  button {
    padding: 10px 20px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: white;
    background: #212121;
    &:disabled {
      opacity: 0.3;
    }
  }
`;

const Wrapper = styled('div')``;

class SearchResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productView: 'grid'
    };
  }
  changeView = view => {
    this.setState({ productView: view });
  };
  render() {
    const { total, term, loading } = this.props;
    const products = get(this.props, 'result', []);

    return (
      <PaginationContext.Consumer>
        {({ currentPage, goToPage, perPage, setProductsPerPage }) => (
          <PaginationBehaviour total={this.props.total}>
            {paginatedProps => (
              <Wrapper>
                <ProductsPerPageFix
                  setProductsPerPage={setProductsPerPage}
                  perPage={50}
                />
                <StyledMaxWidth>
                  <Header>
                    <Container>
                      <Matches>
                        {this.loading ? (
                          currentPage === 1 ? (
                            <div>
                              {t(`Loading search results for {term}…`, {
                                term
                              })}
                            </div>
                          ) : (
                              <div>
                                {t(`Loading page {currentPage}…`, {
                                  currentPage
                                })}
                              </div>
                            )
                        ) : (
                            <div>
                              <h1>Du sökte på: "{term}"</h1>
                              {t(
                                '{total, plural, =1 {# item} other {# items}} matching for "{term}"',
                                {
                                  total,
                                  term
                                }
                              )}
                            </div>
                          )}
                      </Matches>
                    </Container>
                  </Header>
                  {(!this.loading || currentPage > 1) && (
                    <Container>
                      <PaginationBehaviour
                        currentPage={currentPage}
                        goToPage={goToPage}
                        perPage={perPage}
                        total={this.props.total}
                      >
                        {paginationProps => (
                          <Fragment>
                            <Above
                              breakpoint="md"
                              render={() => (
                                <SearchMeta
                                  total={this.props.total}
                                  page={currentPage}
                                  pages={paginationProps.totalPages}
                                />
                              )}
                            />
                            <section>

                              <ProductGrid
                                products={products}
                                listName="search"
                                loading={loading}
                                ProductComponent={GridProduct}
                              />

                            </section>
                            <Pagination {...paginationProps} />
                          </Fragment>
                        )}
                      </PaginationBehaviour>
                    </Container>
                  )}
                </StyledMaxWidth>
              </Wrapper>
            )}
          </PaginationBehaviour>
        )}
      </PaginationContext.Consumer>
    );
  }
}

export default SearchResults;
